import React from 'react'
import Link from 'gatsby-link'

const Header = ({ siteTitle, location }) => (
  <div key={1} className='Header'>
    <div style={{ margin: '0 auto', maxWidth: 960, padding: '1.45rem 1.0875rem', textAlign: 'center'}}>
    {location.pathname === '/' ?
      <h1>
        <Link to="/">✈️  {siteTitle} 😌</Link>
      </h1>
    :
      <Link to="/">✈️  {siteTitle} 😌</Link>
    }
    </div>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js